module.exports = __webpack_public_path__ + "static/img/2.9f96370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/2.png
// module id = +iRU
// module chunks = 1